export const load = () => ({
	title: 'A Noise Complaint in NYC Does Little Without These',
	showTitle: true,
});
